<template>
  <div>
    <validation-observer ref="paymentFileInfoRowForm" novalidate tag="form">
      <div class="row">
        <div class="col">
          <icon-view
            gradient
            :icon="icon"
            icon-background="#f87058"
            icon-color="#fff"
            icon-size="15px"
            :title="title"
            variant="custom-icon-view"
          />
        </div>
      </div>
      <div class="mt-3">
        <div
          v-for="(item, index) in items"
          :key="`file-item-${index}`"
          class="mb-2"
        >
          <custom-callout
            :controlled="true"
            :disabled="allowUploadAnswerFiles(item)"
            :opened="item.isOpen"
            @click:open="onOpenDetails(item)"
          >
            <div class="py-3 px-3">
              <div class="row">
                <div class="col-4 col-sm col-12">
                  <div class="color-secondary-6 font-14 font-weight-normal">
                    Información del Archivo:
                  </div>
                  <div class="color-black font-weight-bold font-16 mr-3">
                    {{ item.fileName }}
                  </div>
                </div>
                <div class="col col-sm col-6 mt-3 mt-md-0 mt-sm-3">
                  <div class="color-secondary-6 font-14 font-weight-normal">
                    Records:
                  </div>
                  <div class="color-black font-weight-bold font-16 mr-3">
                    {{ item.fileRecordCount }}
                  </div>
                </div>
                <div class="col col-sm col-6 mt-3 mt-md-0 mt-sm-3">
                  <div class="color-secondary-6 font-14 font-weight-normal">
                    Error:
                  </div>
                  <div class="color-black font-weight-bold font-16 mr-3">
                    {{ item.fileRecordErrorCount }}
                  </div>
                </div>
                <div class="col col-sm col-12 mt-3 mt-md-0 mt-sm-3">
                  <div class="color-secondary-6 font-14 font-weight-normal">
                    Creador por:
                  </div>
                  <div class="color-black font-weight-bold font-16 mr-3">
                    {{ item.createByName }} / {{ item.createDate | date }}
                  </div>
                </div>
                <div
                  class="col-1 col-sm col-12 d-flex align-items-center justify-content-end pr-5"
                >
                  <action-button
                    class="outline-success pr-1 btn-block-xs-only"
                    i="fa fa-file-download"
                    @click="$emit('on-download-account-file', item)"
                  >
                    <span class="d-inline-block d-md-none d-sm-inline-block">
                      Descargar
                    </span>
                  </action-button>
                </div>
              </div>
              <div class="border-bottom mr-3 mt-3" />
              <div class="mt-3 d-flex align-items-center">
                <div class="color-secondary-6 font-14 font-weight-normal mr-3">
                  Archivos de Respuestas:
                </div>
                <action-button
                  v-if="allowUploadAnswerFiles(item)"
                  class="border btn px-4"
                  i="fas fa-file-plus color-green"
                  text="Presione aquí para anejar documentos"
                  @click="onOpenUploadAnswerFiles(item)"
                />
                <div v-else class="color-gray-6 font-weight-bold font-16">
                  {{ item.answerFileNames }}
                </div>
              </div>
            </div>
            <template #edition>
              <div class="bg-gray p-2">
                <div class="bg-white rounded p-3">
                  <div class="row bg-secondary-3 mx-3 rounded p-3 mb-3">
                    <div class="col-3 d-flex align-items-center">
                      <div class="color-secondary-6 font-16 font-weight-bold">
                        LOG
                      </div>
                    </div>
                    <div class="col d-flex align-items-center">
                      <check-box
                        v-model="item.logFileEmpty"
                        class="w-auto"
                        :disabled="item.logDocumentAttachmentId || logFile"
                      />
                      <div
                        class="color-secondary-6 font-weight-normal font-16 mt-1"
                      >
                        Archivo en Blanco
                      </div>
                    </div>
                    <div class="col d-flex align-items-center">
                      <div class="color-black font-16 font-weight-normal" />
                    </div>
                    <div
                      v-if="
                        hideInEmptyFile(item, 'logDocumentAttachment') ||
                          isReadOnly(item) ||
                          !item.isLastFile
                      "
                      class="d-flex align-items-center"
                    >
                      <custom-file-input
                        v-model="logFile"
                        accept=".log"
                        :attachment-id="item.logDocumentAttachmentId"
                        :disabled="hideRemoveFileLOG(item)"
                        :on-download="onDownloadFile"
                      />
                      <action-button
                        v-if="hideRemoveFileLOG(item) && !isReadOnly(item)"
                        i="fas fa-times-circle"
                        variant="outline-danger btn-cancel danger pt-2 px-3"
                        @click="onDeleteAnswerFile(item)"
                      >
                        Eliminar
                      </action-button>
                    </div>
                  </div>
                  <div class="row bg-secondary-3 mx-3 rounded p-3 mb-3">
                    <div class="col-3 d-flex align-items-center">
                      <div class="color-secondary-6 font-16 font-weight-bold">
                        REJ
                      </div>
                    </div>
                    <div class="col d-flex align-items-center">
                      <check-box
                        v-model="item.rejFileEmpty"
                        class="w-auto"
                        :disabled="item.rejDocumentAttachmentId || rejFile"
                      />
                      <div
                        class="color-secondary-6 font-weight-normal font-16 mt-1"
                      >
                        Archivo en Blanco
                      </div>
                    </div>
                    <div
                      v-if="
                        hideInEmptyFile(item, 'rejDocumentAttachment') ||
                          isReadOnly(item) ||
                          !item.isLastFile
                      "
                      class="d-flex align-items-center"
                    >
                      <custom-file-input
                        v-model="rejFile"
                        accept=".rej"
                        :attachment-id="item.rejDocumentAttachmentId"
                        :disabled="hideRemoveFileREJ(item)"
                        :on-download="onDownloadFile"
                      />
                      <action-button
                        v-if="hideRemoveFileREJ(item) && !isReadOnly(item)"
                        i="fas fa-times-circle"
                        variant="outline-danger btn-cancel danger pt-2 px-3"
                        @click="onDeleteAnswerFile(item)"
                      >
                        Eliminar
                      </action-button>
                    </div>
                  </div>
                  <div v-if="allowSaveUploadAnswerFiles(item)" class="row">
                    <div
                      class="col d-flex justify-content-end align-items-center pr-4 mr-2"
                    >
                      <action-button
                        i="fas fa-times-circle"
                        variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                        @click="onCancelAnswerFile(item)"
                      >
                        Cancelar
                      </action-button>
                      <action-button
                        i="fas fa-save"
                        text="Guardar"
                        variant="success pl-4 pr-4"
                        @click="saveAnswerFiles(item)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </custom-callout>

          <div class="d-flex justify-content-end mt-3">
            <action-button
              v-if="allowModifyFile(item)"
              class="success"
              i="fas fa-file-plus"
              text="Generar Nuevo Archivo"
              @click="generateNewFileHandler(item)"
            />
          </div>
        </div>
      </div>
      <div
        v-if="items.length === 0"
        class="bg-secondary-3 rounded p-4 mt-2 d-flex align-items-center justify-content-center"
      >
        <h1 class="far fa-folder-open color-gray-3" />
        <div class="color-gray-3 font-16 ml-4 font-weight-normal">
          {{ emptyText }}
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import IconView from 'icon-view';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';
import CheckBox from 'CheckBox';
import { serialize as objectToFormData } from 'object-to-formdata';
import alertMixin from 'utils/mixins/alert.mixin';
import paymentJournalStatus from '@/utils/constants/paymentJournalStatus.js';
import interfaceFileAnswerTypes from '@/utils/constants/interfaceAnswerFileType.js';

export default {
  name: 'PaymentFileInfoRow',
  components: {
    IconView,
    CustomCallout,
    ActionButton,
    CustomFileInput,
    CheckBox,
  },
  mixins: [alertMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    emptyText: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    onDownloadFile: {
      type: Function,
      required: true,
    },
    paymentJournalStatusId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      logFile: null,
      rejFile: null,
      model: {
        interfaceFileId: null,
        fileTypeCode: null,
      },
    };
  },
  computed: {
    lastItem() {
      return this.items[this.items.length - 1];
    },
    allowModifyFile() {
      return (item) =>
        item.isLastFile &&
        item.fileRecordErrorCount > 0 &&
        !this.isReadOnly(item);
    },
    allowSaveUploadAnswerFiles() {
      return (item) => !this.isReadOnly(item) && item.isLastFile;
    },
    allowUploadAnswerFiles() {
      return (item) =>
        item.interfaceFileId == this.lastItem?.interfaceFileId &&
        !item.rejDocumentAttachmentId &&
        !item.logDocumentAttachmentId;
    },
    isReadOnly() {
      return (item) =>
        this.paymentJournalStatusId == paymentJournalStatus.Pagado ||
        !item.isLastFile;
    },
    hideRemoveFileLOG() {
      return (item) => item.logDocumentAttachment;
    },
    hideRemoveFileREJ() {
      return (item) => item.rejDocumentAttachment;
    },
    hideInEmptyFile() {
      return (item, doc) => !item[doc] || item.isLastFile;
    },
  },
  methods: {
    generateNewFileHandler(item) {
      this.$emit('on-generate-new-file', { ...item });
    },
    saveAnswerFiles(item) {
      if (item.logFileEmpty && item.rejFileEmpty) {
        this.ShowToast(
          '',
          'Ambos archivos no pueden estar marcados en blanco. (22103)',
          'error'
        );
        return;
      }

      if (
        (item.logFileEmpty && this.logFile != null) ||
        (item.rejFileEmpty && this.rejFile != null)
      ) {
        this.ShowToast(
          '',
          'Si selecciono que el archivo está vacío, no debe haber un archivo anejado',
          'error'
        );
        return;
      }

      if (
        this.logFile == null &&
        !item.logFileEmpty &&
        !item.logDocumentAttachmentId &&
        this.rejFile == null &&
        !item.rejFileEmpty &&
        !item.rejDocumentAttachmentId
      ) {
        this.onCancelAnswerFile(item);
        return;
      }

      if (
        (item.logDocumentAttachment || item.rejDocumentAttachment) &&
        (item.logFileEmpty || item.rejFileEmpty)
      ) {
        this.onCancelAnswerFile(item);
        return;
      }

      this.model.interfaceFileId = item.interfaceFileId;
      this.model.fileTypeCode = item.fileTypeCode;

      let formData = objectToFormData(
        {
          ...this.model,
          logFileEmpty: item.logFileEmpty,
          rejFileEmpty: item.rejFileEmpty,
          files: [this.logFile, this.rejFile],
        },
        { indices: true }
      );

      this.$emit('on-save-answer-files', formData);
    },
    onOpenDetails(item) {
      item.isOpen = !item.isOpen;
      this.$forceUpdate();
    },
    onOpenUploadAnswerFiles(item) {
      item.isOpen = true;
      this.$forceUpdate();
    },
    onCancelAnswerFile(item) {
      item.isOpen = false;
      this.$forceUpdate();
    },
    async onDeleteAnswerFile(item) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar el archivo de resultado?',
        'Sí',
        'No'
      );
      if (answer) {
        this.$emit(
          'on-delete-file-answer',
          item.interfaceFileId,
          item.logDocumentAttachment
            ? interfaceFileAnswerTypes.LOG
            : interfaceFileAnswerTypes.REJ
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
::v-deep .custom-icon-view {
  .gradient {
    color: map-get($colors, 'black') !important;
  }
}

@media only screen and (max-width: 768px) {
  .btn-block-xs-only {
    display: block;
    width: 100%;
    margin-top: 20px;
  }
}
</style>
